import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { DatasourceTableState } from '@y42/datasource';
import { IntegrationTableStore } from './integration-table.store';

@Injectable({ providedIn: 'root' })
export class IntegrationTableStoreQuery extends QueryEntity<DatasourceTableState> {
  constructor(protected store: IntegrationTableStore) {
    super(store);
  }
}
